module.exports = __webpack_public_path__ + "media/images/dividend/il_coupontheme_memorial-08e25d2388980b767a5848248af861df.svg";